import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ICON = {
    saving: '…',
    saved: '✓',
    error: '⚠',
};
/** SaveStatus — stav ulozeni karty (nikdy jen barvou, vzdy ikona + text). */
export function SaveStatus({ status, texts, errorDetail, className }) {
    if (status === 'idle')
        return null;
    const label = status === 'saving' ? texts.saving : status === 'saved' ? texts.saved : (errorDetail ?? texts.error);
    return (_jsxs("p", { role: status === 'error' ? 'alert' : 'status', className: `rh-save-status rh-save-status--${status}${className ? ` ${className}` : ''}`, children: [_jsx("span", { "aria-hidden": "true", children: ICON[status] }), " ", label] }));
}
//# sourceMappingURL=save-status.js.map